import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { TokenExpirationService } from '../token/token-expiration.service';
import { MsalService } from '@azure/msal-angular';
import { TypedTokenStorageService } from '../token/typed-token-storage.service';
import { Observable, from, of } from 'rxjs';
import { map, catchError, timeout } from 'rxjs/operators';
import { AUTH_ROUTES, AUTH_CONFIG } from 'src/app/constants/auth.constants';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private tokenExpirationService: TokenExpirationService,
    private msalService: MsalService,
    private typedTokenStorage: TypedTokenStorageService
  ) {}

  canActivate(): Observable<boolean> | boolean {
    const isLoggedIn = this.authService.isLoggedIn();
    const isExpired = this.tokenExpirationService.isExpired();
    
    if (isLoggedIn && !isExpired) {
      return true;
    }

    const accounts = this.msalService.instance.getAllAccounts();
    
    if (accounts.length > 0) {
      const request = {
        scopes: AUTH_CONFIG.SCOPES,
        account: accounts[0],
      };
      
      return from(this.msalService.instance.acquireTokenSilent(request)).pipe(
        timeout(AUTH_CONFIG.SILENT_RENEWAL_TIMEOUT_MS),
        map(response => {
          this.typedTokenStorage.saveAllTokens(
            response.accessToken,
            response.idToken
          );
          return true;
        }),
        catchError(error => {
          this.router.navigate([AUTH_ROUTES.LOGIN]);
          return of(false);
        })
      );
    }

    this.router.navigate([AUTH_ROUTES.LOGIN]);
    return false;
  }
}
